<div class="default-dialog">
    <div class="dialog-header">
        <h3>{{ 'PRODUCT_DETAILS_DIALOG.HEADER' | translate }}</h3>
        <div class="header-close">
            <button mat-icon-button color="primary" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div class="product-details">
            <div class="product-details-header">
                {{ data.description }}
            </div>
            @for (attribute of data.technicalAttributes; track attribute.attributeId) {
            <div class="product-detail">
                <div class="product-detail-description">
                    {{ attribute.description }}
                </div>
                @for (value of attribute.values; track value.valueId) {
                <div class="product-detail-value">{{ formatDecimalComma(value.value) }} {{ value.unit }}</div>
                }
            </div>
            }
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button mat-dialog-close color="primary">{{ 'COMMON.DIALOG.CLOSE' | translate }}</button>
    </mat-dialog-actions>
</div>
